var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uplink-parameter-values"},[_vm._l((_vm.uplink.parameterValues),function(parameterValue){return [_c('LabelLineValue',{attrs:{"label":parameterValue.parameter.title,"value":parameterValue.formattedValue}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }